module.exports = __webpack_public_path__ + "img/Group302.e6b79eb3.svg";